import { ApplicationConfig, provideZoneChangeDetection, ErrorHandler } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideFirebaseApp, initializeApp, getApp } from '@angular/fire/app';
import { provideFirestore, getFirestore } from '@angular/fire/firestore';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { provideStorage, getStorage } from '@angular/fire/storage';
import { provideFunctions, getFunctions } from '@angular/fire/functions';
import { provideAppCheck, initializeAppCheck, ReCaptchaV3Provider } from '@angular/fire/app-check';
import { environment } from '../environments/environment';
import { GlobalErrorHandler } from './services/global-error-handler.service';

import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }), 
    provideRouter(routes),
    provideAnimations(),
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideAppCheck(() => {
      // In development environments, enable debug mode to bypass attestation checks.
      // This uses the debug token provided to avoid "App attestation failed" errors.
      if (!environment.production) {
        (self as any).FIREBASE_APPCHECK_DEBUG_TOKEN = '8A335E2B-40B1-4A55-A064-C94C79848338';
      }
      
      const provider = new ReCaptchaV3Provider(
        environment.recaptchaSiteKey || '6Lcxyz...placeholder'
      );
      
      return initializeAppCheck(getApp(), {
        provider,
        isTokenAutoRefreshEnabled: true
      });
    }),
    provideFirestore(() => getFirestore()),
    provideAuth(() => getAuth()),
    provideStorage(() => getStorage()),
    provideFunctions(() => getFunctions(getApp(), 'us-central1'))
  ]
};

